import { Modal, Spin } from "antd";
import { useDispatch } from "react-redux";
import { LoadingOutlined } from '@ant-design/icons';
import { useSelector } from "react-redux";

const antIcon = <LoadingOutlined style={{ fontSize: 40, color: '#1D1D1D' }} spin />;

const LoadingModal = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector((app:any) => app.setting.isLoading);
  return (
    <Modal
      className="pinpoint-modal loadingModal bg-transparent"
      width={100}
      centered
      open={isLoading}
      footer={false}
      closable={false}
    >
      <Spin indicator={antIcon} className="text-darkGreen"/>
    </Modal>
  )
}
export default LoadingModal;
